var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminTimeslots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 6.66667C1.6665 4.36548 3.53198 2.5 5.83317 2.5H14.1665C16.4677 2.5 18.3332 4.36548 18.3332 6.66667V14.1667C18.3332 16.4679 16.4677 18.3333 14.1665 18.3333H5.83317C3.53198 18.3333 1.6665 16.4679 1.6665 14.1667V6.66667ZM5.83317 4.16667C4.45246 4.16667 3.33317 5.28595 3.33317 6.66667V14.1667C3.33317 15.5474 4.45246 16.6667 5.83317 16.6667H14.1665C15.5472 16.6667 16.6665 15.5474 16.6665 14.1667V6.66667C16.6665 5.28595 15.5472 4.16667 14.1665 4.16667H5.83317Z",
    fill: "#5A6774"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66634 1.6665C7.12658 1.6665 7.49967 2.0396 7.49967 2.49984V4.99984C7.49967 5.46007 7.12658 5.83317 6.66634 5.83317C6.2061 5.83317 5.83301 5.46007 5.83301 4.99984V2.49984C5.83301 2.0396 6.2061 1.6665 6.66634 1.6665Z",
    fill: "#5A6774"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8.33333C5 7.8731 5.3731 7.5 5.83333 7.5H14.1667C14.6269 7.5 15 7.8731 15 8.33333C15 8.79357 14.6269 9.16667 14.1667 9.16667H5.83333C5.3731 9.16667 5 8.79357 5 8.33333Z",
    fill: "#5A6774"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 14.1668C12.5 13.7066 12.8731 13.3335 13.3333 13.3335L14.1667 13.3335C14.6269 13.3335 15 13.7066 15 14.1668C15 14.6271 14.6269 15.0002 14.1667 15.0002H13.3333C12.8731 15.0002 12.5 14.6271 12.5 14.1668Z",
    fill: "#5A6774"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 1.6665C13.7936 1.6665 14.1667 2.0396 14.1667 2.49984V4.99984C14.1667 5.46007 13.7936 5.83317 13.3333 5.83317C12.8731 5.83317 12.5 5.46007 12.5 4.99984V2.49984C12.5 2.0396 12.8731 1.6665 13.3333 1.6665Z",
    fill: "#5A6774"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminTimeslots);
export default __webpack_public_path__ + "static/media/admin_timeslots.a04b65a2fe32e8b21403a4f38a3ec588.svg";
export { ForwardRef as ReactComponent };